$('.c-legend').on('click', function(event){
    $('.shops-wrapper').addClass('show-tooltips');
});
$('.c-modal__overlay, .c-modal__close').on('click', function(event){
    $('.shops-wrapper').removeClass('show-tooltips');
});
